﻿export enum Ability {
  ABSORB = "ABSORB",
  ACCELEROCK = "ACCELEROCK",
  ACID_ARMOR = "ACID_ARMOR",
  ACID_SPRAY = "ACID_SPRAY",
  ACROBATICS = "ACROBATICS",
  AERIAL_ACE = "AERIAL_ACE",
  AFTER_YOU = "AFTER_YOU",
  AGILITY = "AGILITY",
  AIR_SLASH = "AIR_SLASH",
  ANCHOR_SHOT = "ANCHOR_SHOT",
  ANCIENT_POWER = "ANCIENT_POWER",
  APPLE_ACID = "APPLE_ACID",
  AQUA_JET = "AQUA_JET",
  AQUA_RING = "AQUA_RING",
  AQUA_STEP = "AQUA_STEP",
  AQUA_TAIL = "AQUA_TAIL",
  ARM_THRUST = "ARM_THRUST",
  ARMOR_CANNON = "ARMOR_CANNON",
  AROMATHERAPY = "AROMATHERAPY",
  ASSIST = "ASSIST",
  ASSURANCE = "ASSURANCE",
  ASTRAL_BARRAGE = "ASTRAL_BARRAGE",
  ATTACK_ORDER = "ATTACK_ORDER",
  ATTRACT = "ATTRACT",
  AURA_WHEEL = "AURA_WHEEL",
  AURASPHERE = "AURASPHERE",
  AURORA_BEAM = "AURORA_BEAM",
  AURORA_VEIL = "AURORA_VEIL",
  AXE_KICK = "AXE_KICK",
  BANEFUL_BUNKER = "BANEFUL_BUNKER",
  BARB_BARRAGE = "BARB_BARRAGE",
  BARED_FANGS = "BARED_FANGS",
  BEAT_UP = "BEAT_UP",
  BEHEMOTH_BLADE = "BEHEMOTH_BLADE",
  BIDE = "BIDE",
  BITE = "BITE",
  BITTER_BLADE = "BITTER_BLADE",
  BITTER_MALICE = "BITTER_MALICE",
  BLAST_BURN = "BLAST_BURN",
  BLAZE_KICK = "BLAZE_KICK",
  BLEAKWIND_STORM = "BLEAKWIND_STORM",
  BLIZZARD = "BLIZZARD",
  BLOOD_MOON = "BLOOD_MOON",
  BLUE_FLARE = "BLUE_FLARE",
  BODY_SLAM = "BODY_SLAM",
  BOLT_BEAK = "BOLT_BEAK",
  BONE_ARMOR = "BONE_ARMOR",
  BONEMERANG = "BONEMERANG",
  BOOMBURST = "BOOMBURST",
  BOUNCE = "BOUNCE",
  BRAVE_BIRD = "BRAVE_BIRD",
  BRICK_BREAK = "BRICK_BREAK",
  BUG_BITE = "BUG_BITE",
  BUG_BUZZ = "BUG_BUZZ",
  BULK_UP = "BULK_UP",
  BULLDOZE = "BULLDOZE",
  BULLET_PUNCH = "BULLET_PUNCH",
  BURN_UP = "BURN_UP",
  BURNING_JEALOUSY = "BURNING_JEALOUSY",
  CAMOUFLAGE = "CAMOUFLAGE",
  CAVERNOUS_CHOMP = "CAVERNOUS_CHOMP",
  CEASELESS_EDGE = "CEASELESS_EDGE",
  CHAIN_CRAZED = "CHAIN_CRAZED",
  CHARGE = "CHARGE",
  CHARGE_BEAM = "CHARGE_BEAM",
  CHARM = "CHARM",
  CHATTER = "CHATTER",
  CHLOROBLAST = "CHLOROBLAST",
  CITY_SHUTTLE = "CITY_SHUTTLE",
  CLANGOROUS_SOUL = "CLANGOROUS_SOUL",
  CLOSE_COMBAT = "CLOSE_COMBAT",
  COIL = "COIL",
  COLUMN_CRUSH = "COLUMN_CRUSH",
  CONFUSING_MIND = "CONFUSING_MIND",
  CONFUSION = "CONFUSION",
  CORE_ENFORCER = "CORE_ENFORCER",
  COSMIC_POWER_MOON = "COSMIC_POWER_MOON",
  COSMIC_POWER_SUN = "COSMIC_POWER_SUN",
  COTTON_GUARD = "COTTON_GUARD",
  COTTON_SPORE = "COTTON_SPORE",
  COUNTER = "COUNTER",
  CRABHAMMER = "CRABHAMMER",
  CROSS_POISON = "CROSS_POISON",
  CRUNCH = "CRUNCH",
  CRUSH_CLAW = "CRUSH_CLAW",
  CRUSH_GRIP = "CRUSH_GRIP",
  CURSE = "CURSE",
  CUT = "CUT",
  DARK_HARVEST = "DARK_HARVEST",
  DARK_VOID = "DARK_VOID",
  DARKEST_LARIAT = "DARKEST_LARIAT",
  DECORATE = "DECORATE",
  DEEP_FREEZE = "DEEP_FREEZE",
  DEFAULT = "DEFAULT",
  DEFEND_ORDER = "DEFEND_ORDER",
  DEFENSE_CURL = "DEFENSE_CURL",
  DETECT = "DETECT",
  DIAMOND_STORM = "DIAMOND_STORM",
  DIG = "DIG",
  DIRE_CLAW = "DIRE_CLAW",
  DISABLE = "DISABLE",
  DISARMING_VOICE = "DISARMING_VOICE",
  DISCHARGE = "DISCHARGE",
  DIVE = "DIVE",
  DIZZY_PUNCH = "DIZZY_PUNCH",
  DOOM_DESIRE = "DOOM_DESIRE",
  DOUBLE_EDGE = "DOUBLE_EDGE",
  DOUBLE_IRON_BASH = "DOUBLE_IRON_BASH",
  DOUBLE_SHOCK = "DOUBLE_SHOCK",
  DRACO_METEOR = "DRACO_METEOR",
  DRAGON_BREATH = "DRAGON_BREATH",
  DRAGON_CLAW = "DRAGON_CLAW",
  DRAGON_DARTS = "DRAGON_DARTS",
  DRAGON_ENERGY = "DRAGON_ENERGY",
  DRAGON_PULSE = "DRAGON_PULSE",
  DRAGON_TAIL = "DRAGON_TAIL",
  DRAIN_PUNCH = "DRAIN_PUNCH",
  DREAM_EATER = "DREAM_EATER",
  DRILL_PECK = "DRILL_PECK",
  DRILL_RUN = "DRILL_RUN",
  DRUM_BEATING = "DRUM_BEATING",
  DYNAMAX_CANNON = "DYNAMAX_CANNON",
  DYNAMIC_PUNCH = "DYNAMIC_PUNCH",
  EAR_DIG = "EAR_DIG",
  ECHO = "ECHO",
  EERIE_SPELL = "EERIE_SPELL",
  EGG_BOMB = "EGG_BOMB",
  ELECTRIC_SURGE = "ELECTRIC_SURGE",
  ELECTRIFY = "ELECTRIFY",
  ELECTRO_BALL = "ELECTRO_BALL",
  ELECTRO_SHOT = "ELECTRO_SHOT",
  ELECTRO_WEB = "ELECTRO_WEB",
  ENCORE = "ENCORE",
  ENTANGLING_THREAD = "ENTANGLING_THREAD",
  ENTRAINMENT = "ENTRAINMENT",
  ERUPTION = "ERUPTION",
  EXPANDING_FORCE = "EXPANDING_FORCE",
  EXPLOSION = "EXPLOSION",
  EXTREME_SPEED = "EXTREME_SPEED",
  FACADE = "FACADE",
  FAIRY_LOCK = "FAIRY_LOCK",
  FAIRY_WIND = "FAIRY_WIND",
  FAKE_OUT = "FAKE_OUT",
  FAKE_TEARS = "FAKE_TEARS",
  FEATHER_DANCE = "FEATHER_DANCE",
  FELL_STINGER = "FELL_STINGER",
  FICKLE_BEAM = "FICKLE_BEAM",
  FIERY_DANCE = "FIERY_DANCE",
  FIERY_WRATH = "FIERY_WRATH",
  FILLET_AWAY = "FILLET_AWAY",
  FIRE_BLAST = "FIRE_BLAST",
  FIRE_FANG = "FIRE_FANG",
  FIRE_LASH = "FIRE_LASH",
  FIRE_SPIN = "FIRE_SPIN",
  FIRESTARTER = "FIRESTARTER",
  FIRST_IMPRESSION = "FIRST_IMPRESSION",
  FISHIOUS_REND = "FISHIOUS_REND",
  FISSURE = "FISSURE",
  FLAME_CHARGE = "FLAME_CHARGE",
  FLAMETHROWER = "FLAMETHROWER",
  FLASH = "FLASH",
  FLEUR_CANNON = "FLEUR_CANNON",
  FLING = "FLING",
  FLORAL_HEALING = "FLORAL_HEALING",
  FLOWER_TRICK = "FLOWER_TRICK",
  FLY = "FLY",
  FLYING_PRESS = "FLYING_PRESS",
  FOCUS_PUNCH = "FOCUS_PUNCH",
  FOLLOW_ME = "FOLLOW_ME",
  FORCE_PALM = "FORCE_PALM",
  FORECAST = "FORECAST",
  FOUL_PLAY = "FOUL_PLAY",
  FREEZE_DRY = "FREEZE_DRY",
  FREEZING_GLARE = "FREEZING_GLARE",
  FROST_BREATH = "FROST_BREATH",
  FURY_SWIPES = "FURY_SWIPES",
  FUSION_BOLT = "FUSION_BOLT",
  FUTURE_SIGHT = "FUTURE_SIGHT",
  GEAR_GRIND = "GEAR_GRIND",
  GEOMANCY = "GEOMANCY",
  GIGATON_HAMMER = "GIGATON_HAMMER",
  GLACIAL_LANCE = "GLACIAL_LANCE",
  GLACIATE = "GLACIATE",
  GLAIVE_RUSH = "GLAIVE_RUSH",
  GOLD_RUSH = "GOLD_RUSH",
  GRASS_WHISTLE = "GRASS_WHISTLE",
  GRASSY_SURGE = "GRASSY_SURGE",
  GRAV_APPLE = "GRAV_APPLE",
  GRAVITY = "GRAVITY",
  GROWL = "GROWL",
  GROWTH = "GROWTH",
  GRUDGE = "GRUDGE",
  GRUDGE_DIVE = "GRUDGE_DIVE",
  GUILLOTINE = "GUILLOTINE",
  GULP_MISSILE = "GULP_MISSILE",
  GUNK_SHOT = "GUNK_SHOT",
  HAIL = "HAIL",
  HAPPY_HOUR = "HAPPY_HOUR",
  HARDEN = "HARDEN",
  HEAD_SMASH = "HEAD_SMASH",
  HEADBUTT = "HEADBUTT",
  HEADLONG_RUSH = "HEADLONG_RUSH",
  HEAL_BLOCK = "HEAL_BLOCK",
  HEAL_ORDER = "HEAL_ORDER",
  HEART_SWAP = "HEART_SWAP",
  HEAT_CRASH = "HEAT_CRASH",
  HEAVY_SLAM = "HEAVY_SLAM",
  HELPING_HAND = "HELPING_HAND",
  HEX = "HEX",
  HIDDEN_POWER_A = "HIDDEN_POWER_A",
  HIDDEN_POWER_B = "HIDDEN_POWER_B",
  HIDDEN_POWER_C = "HIDDEN_POWER_C",
  HIDDEN_POWER_D = "HIDDEN_POWER_D",
  HIDDEN_POWER_E = "HIDDEN_POWER_E",
  HIDDEN_POWER_EM = "HIDDEN_POWER_EM",
  HIDDEN_POWER_F = "HIDDEN_POWER_F",
  HIDDEN_POWER_G = "HIDDEN_POWER_G",
  HIDDEN_POWER_H = "HIDDEN_POWER_H",
  HIDDEN_POWER_I = "HIDDEN_POWER_I",
  HIDDEN_POWER_J = "HIDDEN_POWER_J",
  HIDDEN_POWER_K = "HIDDEN_POWER_K",
  HIDDEN_POWER_L = "HIDDEN_POWER_L",
  HIDDEN_POWER_M = "HIDDEN_POWER_M",
  HIDDEN_POWER_N = "HIDDEN_POWER_N",
  HIDDEN_POWER_O = "HIDDEN_POWER_O",
  HIDDEN_POWER_P = "HIDDEN_POWER_P",
  HIDDEN_POWER_Q = "HIDDEN_POWER_Q",
  HIDDEN_POWER_QM = "HIDDEN_POWER_QM",
  HIDDEN_POWER_R = "HIDDEN_POWER_R",
  HIDDEN_POWER_S = "HIDDEN_POWER_S",
  HIDDEN_POWER_T = "HIDDEN_POWER_T",
  HIDDEN_POWER_U = "HIDDEN_POWER_U",
  HIDDEN_POWER_V = "HIDDEN_POWER_V",
  HIDDEN_POWER_W = "HIDDEN_POWER_W",
  HIDDEN_POWER_X = "HIDDEN_POWER_X",
  HIDDEN_POWER_Y = "HIDDEN_POWER_Y",
  HIDDEN_POWER_Z = "HIDDEN_POWER_Z",
  HIGH_HORSEPOWER = "HIGH_HORSEPOWER",
  HIGH_JUMP_KICK = "HIGH_JUMP_KICK",
  HORN_ATTACK = "HORN_ATTACK",
  HORN_DRILL = "HORN_DRILL",
  HORN_LEECH = "HORN_LEECH",
  HURRICANE = "HURRICANE",
  HYDRO_PUMP = "HYDRO_PUMP",
  HYDRO_STEAM = "HYDRO_STEAM",
  HYPER_BEAM = "HYPER_BEAM",
  HYPER_DRILL = "HYPER_DRILL",
  HYPER_VOICE = "HYPER_VOICE",
  HYPERSPACE_FURY = "HYPERSPACE_FURY",
  HYPNOSIS = "HYPNOSIS",
  ICE_BALL = "ICE_BALL",
  ICE_FANG = "ICE_FANG",
  ICE_HAMMER = "ICE_HAMMER",
  ICE_SPINNER = "ICE_SPINNER",
  ICICLE_CRASH = "ICICLE_CRASH",
  ICICLE_MISSILE = "ICICLE_MISSILE",
  ICY_WIND = "ICY_WIND",
  INFERNAL_PARADE = "INFERNAL_PARADE",
  INFESTATION = "INFESTATION",
  INGRAIN = "INGRAIN",
  IRON_DEFENSE = "IRON_DEFENSE",
  IRON_HEAD = "IRON_HEAD",
  IRON_TAIL = "IRON_TAIL",
  IVY_CUDGEL = "IVY_CUDGEL",
  JAW_LOCK = "JAW_LOCK",
  JET_PUNCH = "JET_PUNCH",
  JUDGEMENT = "JUDGEMENT",
  KING_SHIELD = "KING_SHIELD",
  KNOCK_OFF = "KNOCK_OFF",
  KNOWLEDGE_THIEF = "KNOWLEDGE_THIEF",
  KOWTOW_CLEAVE = "KOWTOW_CLEAVE",
  LANDS_WRATH = "LANDS_WRATH",
  LASER_BLADE = "LASER_BLADE",
  LAST_RESPECTS = "LAST_RESPECTS",
  LAVA_PLUME = "LAVA_PLUME",
  LEAF_BLADE = "LEAF_BLADE",
  LEECH_LIFE = "LEECH_LIFE",
  LEECH_SEED = "LEECH_SEED",
  LICK = "LICK",
  LINGERING_AROMA = "LINGERING_AROMA",
  LINK_CABLE = "LINK_CABLE",
  LIQUIDATION = "LIQUIDATION",
  LOCK_ON = "LOCK_ON",
  LOVELY_KISS = "LOVELY_KISS",
  LUNAR_BLESSING = "LUNAR_BLESSING",
  LUNGE = "LUNGE",
  LUSTER_PURGE = "LUSTER_PURGE",
  MACH_PUNCH = "MACH_PUNCH",
  MAGIC_BOUNCE = "MAGIC_BOUNCE",
  MAGIC_POWDER = "MAGIC_POWDER",
  MAGICAL_LEAF = "MAGICAL_LEAF",
  MAGMA_STORM = "MAGMA_STORM",
  MAGNET_BOMB = "MAGNET_BOMB",
  MAGNET_PULL = "MAGNET_PULL",
  MAGNET_RISE = "MAGNET_RISE",
  MAKE_IT_RAIN = "MAKE_IT_RAIN",
  MALIGNANT_CHAIN = "MALIGNANT_CHAIN",
  MANTIS_BLADES = "MANTIS_BLADES",
  MAWASHI_GERI = "MAWASHI_GERI",
  MEDITATE = "MEDITATE",
  MEGA_PUNCH = "MEGA_PUNCH",
  METAL_BURST = "METAL_BURST",
  METAL_CLAW = "METAL_CLAW",
  METEOR_MASH = "METEOR_MASH",
  METRONOME = "METRONOME",
  MIMIC = "MIMIC",
  MIND_BEND = "MIND_BEND",
  MIND_BLOWN = "MIND_BLOWN",
  MIST_BALL = "MIST_BALL",
  MISTY_SURGE = "MISTY_SURGE",
  MOON_DREAM = "MOON_DREAM",
  MOONBLAST = "MOONBLAST",
  MOONGEIST_BEAM = "MOONGEIST_BEAM",
  MORTAL_SPIN = "MORTAL_SPIN",
  MOUNTAIN_GALE = "MOUNTAIN_GALE",
  MUD_BUBBLE = "MUD_BUBBLE",
  MUD_SHOT = "MUD_SHOT",
  MUDDY_WATER = "MUDDY_WATER",
  MULTI_ATTACK = "MULTI_ATTACK",
  MYSTICAL_FIRE = "MYSTICAL_FIRE",
  NASTY_PLOT = "NASTY_PLOT",
  NATURAL_GIFT = "NATURAL_GIFT",
  NIGHT_DAZE = "NIGHT_DAZE",
  NIGHT_SHADE = "NIGHT_SHADE",
  NIGHT_SLASH = "NIGHT_SLASH",
  NIGHTMARE = "NIGHTMARE",
  NO_RETREAT = "NO_RETREAT",
  NUTRIENTS = "NUTRIENTS",
  NUZZLE = "NUZZLE",
  OBLIVION_WING = "OBLIVION_WING",
  OBSTRUCT = "OBSTRUCT",
  OCTAZOOKA = "OCTAZOOKA",
  OCTOLOCK = "OCTOLOCK",
  ORDER_UP = "ORDER_UP",
  ORIGIN_PULSE = "ORIGIN_PULSE",
  OUTRAGE = "OUTRAGE",
  OVERDRIVE = "OVERDRIVE",
  OVERHEAT = "OVERHEAT",
  PARABOLIC_CHARGE = "PARABOLIC_CHARGE",
  PASTEL_VEIL = "PASTEL_VEIL",
  PAYDAY = "PAYDAY",
  PECK = "PECK",
  PETAL_BLIZZARD = "PETAL_BLIZZARD",
  PETAL_DANCE = "PETAL_DANCE",
  PICKUP = "PICKUP",
  PLASMA_FISSION = "PLASMA_FISSION",
  PLASMA_FIST = "PLASMA_FIST",
  PLASMA_FLASH = "PLASMA_FLASH",
  PLASMA_TEMPEST = "PLASMA_TEMPEST",
  PLAY_ROUGH = "PLAY_ROUGH",
  POISON_GAS = "POISON_GAS",
  POISON_JAB = "POISON_JAB",
  POISON_POWDER = "POISON_POWDER",
  POISON_STING = "POISON_STING",
  POLLEN_PUFF = "POLLEN_PUFF",
  POLTERGEIST = "POLTERGEIST",
  POPULATION_BOMB = "POPULATION_BOMB",
  POWDER = "POWDER",
  POWDER_SNOW = "POWDER_SNOW",
  POWER_HUG = "POWER_HUG",
  POWER_WASH = "POWER_WASH",
  POWER_WHIP = "POWER_WHIP",
  PRECIPICE_BLADES = "PRECIPICE_BLADES",
  PRESENT = "PRESENT",
  PRISMATIC_LASER = "PRISMATIC_LASER",
  PROTECT = "PROTECT",
  PSYBEAM = "PSYBEAM",
  PSYCHIC = "PSYCHIC",
  PSYCHIC_FANGS = "PSYCHIC_FANGS",
  PSYCHIC_SURGE = "PSYCHIC_SURGE",
  PSYCHO_BOOST = "PSYCHO_BOOST",
  PSYCHO_CUT = "PSYCHO_CUT",
  PSYCHO_SHIFT = "PSYCHO_SHIFT",
  PSYSHIELD_BASH = "PSYSHIELD_BASH",
  PSYSHOCK = "PSYSHOCK",
  PSYSTRIKE = "PSYSTRIKE",
  PUMMELING_PAYBACK = "PUMMELING_PAYBACK",
  PURIFY = "PURIFY",
  PYRO_BALL = "PYRO_BALL",
  QUIVER_DANCE = "QUIVER_DANCE",
  RAGE = "RAGE",
  RAGING_BULL = "RAGING_BULL",
  RAPID_SPIN = "RAPID_SPIN",
  RAZOR_LEAF = "RAZOR_LEAF",
  RAZOR_WIND = "RAZOR_WIND",
  RECOVER = "RECOVER",
  REFLECT = "REFLECT",
  RELIC_SONG = "RELIC_SONG",
  RETALIATE = "RETALIATE",
  RETURN = "RETURN",
  REVELATION_DANCE = "REVELATION_DANCE",
  ROAR = "ROAR",
  ROAR_OF_TIME = "ROAR_OF_TIME",
  ROCK_ARTILLERY = "ROCK_ARTILLERY",
  ROCK_HEAD = "ROCK_HEAD",
  ROCK_SLIDE = "ROCK_SLIDE",
  ROCK_SMASH = "ROCK_SMASH",
  ROCK_TOMB = "ROCK_TOMB",
  ROCK_WRECKER = "ROCK_WRECKER",
  ROLLOUT = "ROLLOUT",
  ROOST = "ROOST",
  SACRED_SWORD_CAVERN = "SACRED_SWORD_CAVERN",
  SACRED_SWORD_GRASS = "SACRED_SWORD_GRASS",
  SACRED_SWORD_IRON = "SACRED_SWORD_IRON",
  SALT_CURE = "SALT_CURE",
  SAND_SPIT = "SAND_SPIT",
  SAND_TOMB = "SAND_TOMB",
  SANDSEAR_STORM = "SANDSEAR_STORM",
  SCALE_SHOT = "SCALE_SHOT",
  SCHOOLING = "SCHOOLING",
  SCREECH = "SCREECH",
  SEARING_SHOT = "SEARING_SHOT",
  SECRET_SWORD = "SECRET_SWORD",
  SEED_FLARE = "SEED_FLARE",
  SEISMIC_TOSS = "SEISMIC_TOSS",
  SHADOW_BALL = "SHADOW_BALL",
  SHADOW_BONE = "SHADOW_BONE",
  SHADOW_CLAW = "SHADOW_CLAW",
  SHADOW_CLONE = "SHADOW_CLONE",
  SHADOW_FORCE = "SHADOW_FORCE",
  SHADOW_PUNCH = "SHADOW_PUNCH",
  SHADOW_SNEAK = "SHADOW_SNEAK",
  SHED_TAIL = "SHED_TAIL",
  SHEER_COLD = "SHEER_COLD",
  SHELL_SIDE_ARM = "SHELL_SIDE_ARM",
  SHELL_SMASH = "SHELL_SMASH",
  SHELL_TRAP = "SHELL_TRAP",
  SHELTER = "SHELTER",
  SHIELDS_DOWN = "SHIELDS_DOWN",
  SHIELDS_UP = "SHIELDS_UP",
  SHOCKWAVE = "SHOCKWAVE",
  SHORE_UP = "SHORE_UP",
  SILK_TRAP = "SILK_TRAP",
  SILVER_WIND = "SILVER_WIND",
  SING = "SING",
  SKETCH = "SKETCH",
  SKILL_SWAP = "SKILL_SWAP",
  SKITTER_SMACK = "SKITTER_SMACK",
  SKY_ATTACK = "SKY_ATTACK",
  SKY_ATTACK_SHADOW = "SKY_ATTACK_SHADOW",
  SLACK_OFF = "SLACK_OFF",
  SLASH = "SLASH",
  SLASHING_CLAW = "SLASHING_CLAW",
  SLUDGE = "SLUDGE",
  SLUDGE_WAVE = "SLUDGE_WAVE",
  SMOG = "SMOG",
  SMOKE_SCREEN = "SMOKE_SCREEN",
  SNIPE_SHOT = "SNIPE_SHOT",
  SNORE = "SNORE",
  SOAK = "SOAK",
  SOFT_BOILED = "SOFT_BOILED",
  SOLAR_BEAM = "SOLAR_BEAM",
  SOLAR_BLADE = "SOLAR_BLADE",
  SONG_OF_DESIRE = "SONG_OF_DESIRE",
  SOUL_TRAP = "SOUL_TRAP",
  SPACIAL_REND = "SPACIAL_REND",
  SPARK = "SPARK",
  SPARKLING_ARIA = "SPARKLING_ARIA",
  SPECTRAL_THIEF = "SPECTRAL_THIEF",
  SPICY_EXTRACT = "SPICY_EXTRACT",
  SPIKES = "SPIKES",
  SPIKY_SHIELD = "SPIKY_SHIELD",
  SPIN_OUT = "SPIN_OUT",
  SPIRIT_BREAK = "SPIRIT_BREAK",
  SPIRIT_SHACKLE = "SPIRIT_SHACKLE",
  SPITE = "SPITE",
  SPLASH = "SPLASH",
  SPRINGTIDE_STORM = "SPRINGTIDE_STORM",
  STATIC_SHOCK = "STATIC_SHOCK",
  STEALTH_ROCKS = "STEALTH_ROCKS",
  STEAM_ERUPTION = "STEAM_ERUPTION",
  STEAMROLLER = "STEAMROLLER",
  STEEL_WING = "STEEL_WING",
  STICKY_WEB = "STICKY_WEB",
  STOCKPILE = "STOCKPILE",
  STOMP = "STOMP",
  STONE_AXE = "STONE_AXE",
  STONE_EDGE = "STONE_EDGE",
  STORED_POWER = "STORED_POWER",
  STRANGE_STEAM = "STRANGE_STEAM",
  STRENGTH = "STRENGTH",
  STRING_SHOT = "STRING_SHOT",
  STRUGGLE_BUG = "STRUGGLE_BUG",
  STUFF_CHEEKS = "STUFF_CHEEKS",
  STUN_SPORE = "STUN_SPORE",
  SUBSTITUTE = "SUBSTITUTE",
  SUCTION_HEAL = "SUCTION_HEAL",
  SUNSTEEL_STRIKE = "SUNSTEEL_STRIKE",
  SUPER_FANG = "SUPER_FANG",
  SUPER_HEAT = "SUPER_HEAT",
  SUPERCELL_SLAM = "SUPERCELL_SLAM",
  SURF = "SURF",
  SURGING_STRIKES = "SURGING_STRIKES",
  SWAGGER = "SWAGGER",
  SWALLOW = "SWALLOW",
  SWARM = "SWARM",
  SWEET_SCENT = "SWEET_SCENT",
  SYRUP_BOMB = "SYRUP_BOMB",
  TACKLE = "TACKLE",
  TAIL_GLOW = "TAIL_GLOW",
  TAIL_WHIP = "TAIL_WHIP",
  TAILWIND = "TAILWIND",
  TAKE_HEART = "TAKE_HEART",
  TAUNT = "TAUNT",
  TEA_TIME = "TEA_TIME",
  TEETER_DANCE = "TEETER_DANCE",
  TELEPORT = "TELEPORT",
  TERRAIN_PULSE = "TERRAIN_PULSE",
  THIEF = "THIEF",
  THOUSAND_ARROWS = "THOUSAND_ARROWS",
  THRASH = "THRASH",
  THUNDER = "THUNDER",
  THUNDERCLAP_PRESS = "THUNDERCLAP_PRESS",
  THUNDER_CAGE = "THUNDER_CAGE",
  THUNDER_FANG = "THUNDER_FANG",
  THUNDER_SHOCK = "THUNDER_SHOCK",
  THUNDEROUS_KICK = "THUNDEROUS_KICK",
  TICKLE = "TICKLE",
  TIME_TRAVEL = "TIME_TRAVEL",
  TOPSY_TURVY = "TOPSY_TURVY",
  TORCH_SONG = "TORCH_SONG",
  TORMENT = "TORMENT",
  TOXIC = "TOXIC",
  TRANSE = "TRANSE",
  TRANSFORM = "TRANSFORM",
  TRI_ATTACK = "TRI_ATTACK",
  TRICK_OR_TREAT = "TRICK_OR_TREAT",
  TRIMMING_MOWER = "TRIMMING_MOWER",
  TRIPLE_DIVE = "TRIPLE_DIVE",
  TRIPLE_KICK = "TRIPLE_KICK",
  TROP_KICK = "TROP_KICK",
  TWIN_BEAM = "TWIN_BEAM",
  TWINEEDLE = "TWINEEDLE",
  TWISTER = "TWISTER",
  U_TURN = "U_TURN",
  ULTRA_THRUSTERS = "ULTRA_THRUSTERS",
  UNBOUND = "UNBOUND",
  UPROAR = "UPROAR",
  VENOSHOCK = "VENOSHOCK",
  VESPIQUEN_ORDERS = "VESPIQUEN_ORDERS",
  VICTORY_DANCE = "VICTORY_DANCE",
  VINE_WHIP = "VINE_WHIP",
  VISE_GRIP = "VISE_GRIP",
  VOLT_SURGE = "VOLT_SURGE",
  VOLT_SWITCH = "VOLT_SWITCH",
  WATER_PULSE = "WATER_PULSE",
  WATER_SHURIKEN = "WATER_SHURIKEN",
  WATERFALL = "WATERFALL",
  WAVE_SPLASH = "WAVE_SPLASH",
  WHEEL_OF_FIRE = "WHEEL_OF_FIRE",
  WHIRLPOOL = "WHIRLPOOL",
  WHIRLWIND = "WHIRLWIND",
  WICKED_BLOW = "WICKED_BLOW",
  WILDBOLT_STORM = "WILDBOLT_STORM",
  WISE_YAWN = "WISE_YAWN",
  WISH = "WISH",
  WONDER_GUARD = "WONDER_GUARD",
  WONDER_ROOM = "WONDER_ROOM",
  WOOD_HAMMER = "WOOD_HAMMER",
  X_SCISSOR = "X_SCISSOR",
  YAWN = "YAWN",
  ZAP_CANNON = "ZAP_CANNON",
  ZING_ZAP = "ZING_ZAP",
  DRAGON_RAGE = "DRAGON_RAGE"
}
